import type {ThemeBreakpoints} from '_uiComponents'

const homePage = {
    HomePage: {
        baseStyle: ({accessibilityBannerSize}: {accessibilityBannerSize: ThemeBreakpoints}) => ({
            container: {
                gap: 0,
                w: '100%',
                pt: {
                    base: `${accessibilityBannerSize.base || 0}px`,
                    sm: `${accessibilityBannerSize.sm || 0}px`,
                    md: `${accessibilityBannerSize.md || 0}px`,
                    lg: `${accessibilityBannerSize.lg || 0}px`,
                    xl: `${accessibilityBannerSize.xl || 0}px`,
                    '2xl': `${accessibilityBannerSize['2xl'] || 0}px`,
                },
            },
        }),
    },
}

export default homePage
